<template>
  <div class="flex-1 h-full overflow-auto bg-neutral-100">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'IntegrationsLayout',
};
</script>
